import { render, staticRenderFns } from "./InfoCustomer.vue?vue&type=template&id=7ea5867a&scoped=true&"
import script from "./InfoCustomer.vue?vue&type=script&lang=js&"
export * from "./InfoCustomer.vue?vue&type=script&lang=js&"
import style0 from "./InfoCustomer.vue?vue&type=style&index=0&id=7ea5867a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea5867a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VImg})
